
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import MaderasSection from '../../components/feature/MaderasSection';

export default function MaderasPage() {
  return (
    <>
      <link href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@300;400;500;600;700&family=Cormorant+Garamond:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
      
      <div className="min-h-screen">
        <Header />
        
        {/* Hero Section */}
        <div className="bg-white">
          <div className="w-full mx-auto text-center flex items-center justify-center min-h-screen" style={{ padding: 'clamp(2rem, 4vh, 6rem) clamp(1rem, 3vw, 5rem)' }}>
            <div>
              <h1 
                className="font-light text-gray-900" 
                style={{ 
                  fontFamily: 'Playfair Display, serif',
                  fontSize: 'clamp(2.5rem, 5vw, 7rem)',
                  marginBottom: 'clamp(1rem, 2vh, 3rem)'
                }}
              >
                MADERAS NATURALES
              </h1>
              <p 
                className="text-gray-900 max-w-[1400px] mx-auto leading-relaxed" 
                style={{ 
                  fontFamily: 'Cormorant Garamond, serif',
                  fontSize: 'clamp(1rem, 1.2vw, 2rem)',
                  padding: '0 clamp(1rem, 2vw, 3rem)'
                }}
              >
                <b>Fabricado sobre tablero marino hidrófugo. Láminas exteriores compuestas por la madera natural escogida. Núcleo compuesto por láminas de madera de abedul macizas.</b>
                <br /><br />
                <b>Tratamiento especial para resistir la humedad del baño</b>
              </p>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <MaderasSection />

        <Footer />
      </div>
    </>
  );
}
